import {DROPDOWN_SELECT_FOR_ARRAY_CURRENT_REQUEST} from "../../../../enums/Request/currentRequestControls.types";

export const dropdownSelectionForArrayCurrenRequest = (e, array, stateproperty) => {
    return {
        type: DROPDOWN_SELECT_FOR_ARRAY_CURRENT_REQUEST,
        payload: {array, stateproperty},
    };
};
